import { render, staticRenderFns } from "./parameter.vue?vue&type=template&id=04eab136&scoped=true"
import script from "./parameter.vue?vue&type=script&lang=js"
export * from "./parameter.vue?vue&type=script&lang=js"
import style0 from "./parameter.vue?vue&type=style&index=0&id=04eab136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eab136",
  null
  
)

export default component.exports